import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: white;
  padding: 0;
  max-width: 1250px;
`
